import { useEffect } from "react";
import { intercomService } from "../../services/IntercomService";

export function GuestIntercomMessenger() {
  const appId = process.env.REACT_APP_INTERCOM_APP_ID;

  useEffect(() => {
    console.log("Intercom App ID inside useEffect:", appId);
    if (appId) {
      intercomService.guestBoot({
        appId: appId,
      });
    }

    return () => {
      if (appId) {
        intercomService.shutdown();
      }
    };
  }, [appId]);

  return null;
}
